import dynamic from 'next/dynamic';
const ClientsLogo = dynamic(() => import('./ClientsLogo'));
export default ClientsLogo;
